import { z } from "zod";

const MAX_NAME_LENGTH = 255;
const MAX_DESCRIPTION_LENGTH = 500;

export type Organization = {
  organization_id: string;
  name: string;
  description: string;
  created_at: string;
  is_default: boolean;
  /** Whether the caller may edit this org (backend `can_edit`; mirrors the update gate). */
  can_edit: boolean;
};

// Zod schema for editing organization
export const EditOrganizationSchema = z.object({
  name: z.string().min(1, "Organization name is required").max(MAX_NAME_LENGTH),
  description: z.string().max(MAX_DESCRIPTION_LENGTH).optional(),
});

export type EditOrganizationFormData = z.infer<typeof EditOrganizationSchema>;
